import axios from 'axios';

export default async function getCompanyGroupGuests({
  accessToken,
  companyGroupId,
  page = 0,
  pageSize = 100,
  query = '',
}) {
  const requestOptions = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  const { data } = await axios.get(
    `${process.env.REACT_APP_GUESTS_API_URL}/company-group/${companyGroupId}?page=${page}&pageSize=${pageSize}&query=${query}`,
    requestOptions,
  );

  return data;
}
